// extracted by mini-css-extract-plugin
module.exports = {"off-grid-P":"P_off-grid-P__pTbw7"};